import React from 'react'
import { Typography, Chip, CircularProgress } from '@material-ui/core'
import { TASK_STATUS_LABELS, TASK_STATUS_COLORS } from '../../constants/bidStatuses'

const formatDate = (d) => {
  if (!d) return ''
  return new Date(d).toLocaleDateString()
}

const TasksTab = ({ items, loading, onEdit }) => {
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}><CircularProgress size={20} /></div>
  if (items.length === 0) {
    return <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>No tasks yet.</Typography>
  }
  return items.map((task) => (
    <div
      key={task._id}
      style={{ padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)', cursor: 'pointer' }}
      onClick={() => onEdit('task', task)}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <Chip
          label={TASK_STATUS_LABELS[task.status] || task.status}
          size="small"
          style={{ height: 20, fontSize: 11, backgroundColor: TASK_STATUS_COLORS[task.status] || '#9e9e9e', color: '#fff' }}
        />
        {task.dueDate && <span style={{ fontSize: 11, color: 'var(--ink-3)' }}>Due {formatDate(task.dueDate)}</span>}
      </div>
      <div style={{ fontSize: 13, fontWeight: 500 }}>{task.title}</div>
      {task.assignees && task.assignees.length > 0 && (
        <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>
          {task.assignees.map(a => a.name || a).join(', ')}
        </div>
      )}
    </div>
  ))
}

export default TasksTab
